<ion-header class="extendido">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>{{'Programação' | translate}}</ion-title>
  </ion-buttons>
</ion-header>

<ion-content>
  <div class="gradient-extendido"></div>

  <ion-row>
    <ion-col class="schedule-data">
      <div class="item-content">
        <h2 class="item-title one-line bold-2" text-uppercase>{{programacao.descricao}}</h2>

        <div class="item-description">
          <p class="description-text">{{programacao.horaInicio}} {{'Até' | translate}} {{programacao.horaFim}}</p>
        </div>

        <div class="item-description">
          <p class="description-text">{{programacao.cultoProgramacaoTipo.descricao }}</p>
        </div>
      </div>
    </ion-col>
  </ion-row>

  <ion-grid class="schedule-data">
    <ion-note slot="start">
      <i class="fas fa-user-friends div-icon"></i>
    </ion-note>
    <ion-label class="item-title"> {{'Responsáveis' | translate}} </ion-label>

    <ion-row *ngFor="let p of programacao.responsaveis">
      <ion-col class="border-bottom">
        <ion-item>
          <ion-avatar slot="start">
            <ion-img [src]="p.pessoa.foto | image:' '"></ion-img>
          </ion-avatar>

          <ion-label>
            <h3>{{p.pessoa.nome}}</h3>
          </ion-label>
        </ion-item>
      </ion-col>
    </ion-row>
  </ion-grid>

  <sem-registro *ngIf="!programacao.responsaveis.length"> </sem-registro>
</ion-content>
